import React from 'react';
import "../styles/Component1.css"
import phone from "../images/phone.png"
import apple from "../images/appstore.png"
import google from "../images/google_store.png"


const Component1 = () => {
  return (
    <div class="container">

    <div class="left-bar">
      <p class="any-face">Any Face now</p>
      <p class="dances-with">Dances with one click</p>
      <p class="content">UGC Creator enables you to create funny animations with your photos!</p>
    
      <div class="button-container">
      <button style={{ border: "none", background: "transparent" }}>
        <img src={apple} alt="Logo" width="250" height="70" />
      </button>
      <button style={{ border: "none", background: "transparent" }}>
        <img src={google} alt="Logo" width="250" height="72" />
      </button>
      </div>
    </div>
  
  
    <div class="right-bar">
      <img src={phone} alt="Resim" />
    </div>
  </div>
  
  );
};

export default Component1;  
